import React, { useState, useImperativeHandle, useRef } from 'react';
import { Upload, Icon } from "@tencent/universe-ui/build/lib";
import { Button, Input,MessagePlugin,Tooltip } from 'tdesign-react';
import { isLogin } from '../../utils/index.js';
const URL_EXP = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;

const FileToBase64 = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
};

function getFileType(url, acceptList, uploadExtList = []) {
  let fileList = uploadExtList.concat(acceptList);
  let acList = fileList.filter((i) => { return url.indexOf(i) > -1 })
  //获取文件类型
  return acList.length > 0 ? acList[acList.length - 1] : ''
}


export default ({ curItem, acceptList = ['jpg', 'jpeg', 'png'], prefix = "Image", onSuccess, maxLength = 10, cRef }) => {
  useImperativeHandle(cRef, () => ({
    onUpload: () => {
      clickBtn?.current.click()
    }
  }));
  const [status, setStatus] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  const clickBtn = useRef();

  const showErrorMsg = (msg) => {
        MessagePlugin.error({
        content:msg,
        duration:3000,
        className:'ocrDemo-messgae-error',
        icon:<span className="ocrDemo-icon-errorMsg"></span>
      })
  }

  const beforeUpload = (file, fileList, isAccepted, reasons) => {
    return new Promise(async (resolve, reject) => {
      isLogin();
      const imageBase64 = await FileToBase64(file);
      if (!file) {
        showErrorMsg('请选择文件')
        return reject()
      };
      const ext = file.name.split('.').pop().toLowerCase();
      if (!acceptList.includes(ext)) {
        showErrorMsg(curItem.uploadExtErrorMsg ? <>体验页面不支持{ext}格式，请点击<a style={{ color: '#4A70FF' }} target="_blank" href={curItem.url}>{curItem.title}</a>调用API接口</> : '文件格式不正确')
        return reject()
      }
      if (imageBase64?.length > maxLength * 1024 * 1024) {
        showErrorMsg(`文件大小不能超过${maxLength}M`)
        return reject()
      }
      let _url = imageBase64;
      if (prefix === 'OfdFile') {
        _url = imageBase64.replace('data:application/octet-stream;base64,', '')
      } else if (ext === 'bmp') {
        _url = imageBase64.replace('data:image/bmp;base64,', '')
      } else if (['docx', 'doc', 'xlsx', 'xls'].includes(ext)) {
        _url = imageBase64.replace(/data.+?;base64,/, '')
      }


      onSuccess && onSuccess({
        img: {
          type: 'base64',
          previewUrl: imageBase64,
          OriginUrl: _url,
          url: _url,
          base64prefix: '',
          prefix: `${prefix}Base64`,
          isExample: false,
          pageNum: 1,
          fileType: ext,
          cantPreview: false,
        },
        type: ext,
      });
      return reject()
    })
  };

  const handleStart = (file, context) => {
    setStatus('validating');
  };

  const handleSuccess = (result, context) => {
    setStatus('success');
  };

  const handleError = (error, context) => {
    setStatus('error');
  };

  const handleCheckBefore = () => {
    let ext = getFileType(imgUrl, acceptList, curItem.uploadExtList);
    if (!URL_EXP.test(imgUrl)) {
      showErrorMsg('请输入正确的url地址')
    } else if (acceptList.filter((i) => { return ext === (i).toLowerCase() }).length <= 0) {
      showErrorMsg(curItem.uploadExtErrorMsg ? <>体验页面不支持{ext}格式，请点击<a style={{ color: '#4A70FF' }} target="_blank" href={curItem.url}>{curItem.title}</a>调用API接口</> : '文件格式不正确')
    } else {
      onSuccess && onSuccess({
        img: {
          type: 'url',
          url: imgUrl,
          OriginUrl: imgUrl,
          prefix: `${prefix}Url`,
          fileType: ext,
          pageNum: 1,
          isExample: false,
          cantPreview: false,
        },
        type: ext,
      });
      setImgUrl('');
    }
  }

  return (
    <div className="ocr_upload__container">
      <div className="ocr_upload__width"
      >
        <Upload
          beforeUpload={beforeUpload}
          onStart={handleStart}
          onSuccess={handleSuccess}
          onError={handleError}
        >
          <Tooltip content={`支持${acceptList.join('、')}等格式，大小不超过${maxLength}M`} theme="light">
            <Button
              type="button"
              variant="base"
              ref={clickBtn}
              onClick={async (event) => {
                await isLogin(event);
              }}
              // type="hole"
              width="full"
            >
              上传本地文件
            </Button>
          </Tooltip>
        </Upload>
        <div className="unv-upload__btn-extra">
          <span className="unv-upload__btn-extra__tips">
            或
          </span>
          <Input
            prefixIcon={<span className="ocrDemo-icon_search" onClick={handleCheckBefore}></span>}
            suffixIcon={<span className="ocrDemo-icon_enter" onClick={handleCheckBefore}></span>}
            style={{ width: "100%" }}
            value={imgUrl}
            onEnter={handleCheckBefore}
            onChange={(e) => { setImgUrl(e) }}
            placeholder={`输入在线URL,回车发起调用，支持${acceptList.join('、')}等格式，大小不超过${maxLength}M`} />
        </div>
      </div>
      {
        curItem.uploadErrorMsg && <div className="ocrDemo_upload__des">{curItem.uploadErrorMsg}</div>
      }
      
    </div>

  );
};